import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full p-2"
}
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Loading scorecards...")

import { useScorecardStore } from '@/store/scorecards';
import { useUserStore } from '@/store/users';
import { Scorecard, UserScorecard } from '@/typings/scorecard';
import PreviewCard from '@/components/Scorecard/PreviewCard.vue';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const scorecardStore = useScorecardStore();

const scorecards = ref<UserScorecard[]>([]);

const viewedUser = computed(() => userStore.secureUser || userStore.viewUser);

onMounted(() => {
  if (viewedUser.value) {
    scorecardStore.getScorecardsByUser(viewedUser.value.Uuid).then((s) => {
      if (s) {
        scorecards.value = s;
      }
    });
  }
});

const router = useRouter();

function viewScorecard(scorecard: Scorecard) {
  if (userStore.viewUser) {
    router.push({
      name: 'ScorecardUser',
      params: {
        slug: scorecard.Slug,
        user: viewedUser.value?.Name,
      },
    });
  } else {
    router.push({
      name: 'Scorecard',
      params: {
        slug: scorecard.Slug,
      },
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (scorecards.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scorecards.value, (scorecard) => {
            return (_openBlock(), _createBlock(PreviewCard, {
              key: scorecard.event.Slug,
              scorecard: scorecard.event,
              onClick: ($event: any) => (viewScorecard(scorecard.event)),
              score: scorecard.usersAnswers.Score
            }, null, 8, ["scorecard", "onClick", "score"]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }))
}
}

})